import React /*, {useEffect}*/ from 'react';

import Toggle from '../darkModeSettings/Toggle';
import useDarkMode from 'use-dark-mode';

const DarkModeToggle = () => {
  const darkMode = useDarkMode(false);

  // useEffect(() => {
  //       enableDarkMode();
  //        // eslint-disable-next-line react-hooks/exhaustive-deps
  // },[]);

  // function enableDarkMode(){
  //     darkMode.enable() 
  // }

  return (
    <div className="dark-mode-toggle">
      <button type="button" onClick={darkMode.disable}>
        ☀
      </button>
      <Toggle checked={darkMode.value} onChange={darkMode.toggle} />
      <button type="button" onClick={darkMode.enable}>
        ☾
      </button>
    </div>
  );
};

export default DarkModeToggle;
